<div class="full-width-container">
  <slot />
</div>

<style lang="scss">
  @import 'src/scss/media';
  @import 'src/scss/variables';

  $full-width: $max-width-page - 2 * $max-width-margin;

  .full-width-container {
    overflow: hidden;
    position: relative;
    margin: var(--twist-core-spacing-0) auto;

    @include at('max') {
      max-width: $full-width;
    }
  }
</style>
